/**
 * MSW Missed Visit — options + empty payload.
 * After shared common header (1–6): Reason → Attempts → Impact → Coordination → Follow-up.
 */

import { emptyMswCommonHeader } from "./mswNotesCommonHeaderUtils";

export const MISSED_REASON_OPTIONS = [
  "Patient/Caregiver not available",
  "Not feeling well",
  "Inclement weather",
  "MD appointment",
  "Cancelled/Rescheduled",
  "Hospitalized",
  "No safe access",
  "Refused visit",
  "Out of town",
  "No caregiver present",
  "Other",
];

export const ATTEMPT_COUNT_OPTIONS = ["1", "2", "3+"];

export const CONTACT_METHOD_OPTIONS = [
  "Phone Call",
  "SMS/Text",
  "Voicemail Left",
];

export const YES_NO_OPTIONS = ["Yes", "No"];

export const COORDINATION_DISCIPLINE_OPTIONS = [
  "RN",
  "PT",
  "OT",
  "ST",
  "MSW",
  "HHA",
];

export const toggleInList = (list, item) => {
  const arr = Array.isArray(list) ? list : [];
  return arr.includes(item) ? arr.filter((x) => x !== item) : [...arr, item];
};

export const today = () => new Date().toISOString().slice(0, 10);

/** Full editable MSW Missed Visit payload (JSON on dedicated row). */
export const emptyMswMissedVisitPayload = () => ({
  billingCode: "",
  timeIn: "",
  timeOut: "",

  missedVisitDate: "",
  commonHeader: emptyMswCommonHeader(),

  // —— 7. Reason for Missed Visit ——
  missedReasons: [],
  reasonOtherSpecify: "",

  // —— 8. Attempts Made ——
  attemptsCount: "",
  contactMethods: [],

  // —— 9. Impact on Plan of Care ——
  interventionsGoalsAffected: "",
  functionalImpact: "",
  patientAwareOfNextVisit: "",

  // —— 10. Coordination & Notifications ——
  physicianNotified: false,
  physicianNotifiedDate: "",
  physicianNotifiedTime: "",
  familyNotified: false,
  familyNotifiedDate: "",
  familyNotifiedTime: "",
  caseManagerNotified: false,
  caseManagerNotifiedDate: "",
  caseManagerNotifiedTime: "",

  // —— 11. Follow-up Plan ——
  rescheduledDate: "",
  nextScheduledFrequency: "",
  clinicalStrategy: "",
  coordinationDisciplines: [],
});

export const MSW_MISSED_ARRAY_KEYS = [
  "missedReasons",
  "contactMethods",
  "coordinationDisciplines",
];
